import moment from 'moment'

const STATUS_CHOICES = {
    R: 'Received',
    O: 'Outstanding'
}

export function cleanPurchaseOrderData(orders) {
    // loop through all orders and set the numItems and status keys
    return orders.map(order => {
        return {
            ...order,
            job: order.job ? order.job.name : null,
            customerName: order.job ? order.job.customerName : null,
            totalCents: `$${order.totalCents / 100}`,
            numItems: order.orderItems ? order.orderItems.length : 0,
            status: STATUS_CHOICES[order.status],
            datetimeCreated: moment(order.datetimeCreated).format("MM/DD/YYYY")
        }
    })
}